"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertAfter = void 0;
function insertAfter(node, preceding) {
    var next = preceding.nextSibling;
    var parent = preceding.parentNode;
    if (next) {
        parent.insertBefore(node, next);
    }
    else {
        parent.appendChild(node);
    }
    return node;
}
exports.insertAfter = insertAfter;
//# sourceMappingURL=insert-after.js.map